export default "__VITE_ASSET__Df6ayG62__"